<template>
    <div>
        <nav class="sidebar-content">
            <ul class="nav flex-column">
                <!-- MY PHARMACY -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'my_pharmacy' }"
                        class="nav-link"
                        :class="{ active: activeLink('my_pharmacy') }"
                    >
                        {{ $t('my_pharmacy') }}
                    </router-link>
                </li>
                <!-- PHARMACIES -->
                <!-- Shown if current user is superadmin -->
                <li v-if="user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'pharmacy.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('pharmacy.index') }"
                    >
                        {{ $t('pharmacies') }}
                    </router-link>
                </li>
                <!-- WEB USERS -->
                <!-- Shown if current user is superadmin -->
                <li v-if="user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'webUser.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('webUser.index') }"
                    >
                        {{ $t('web_users') }}
                    </router-link>
                </li>
                <!-- USERS -->
                <!-- Shown if current user has show_user permission and is not superadmin -->
                <li v-if="user.permissions.show_user && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'user.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('user.index') }"
                    >
                        {{ $t('users') }}
                    </router-link>
                </li>
                <!-- ROLES AND PERMISSIONS -->
                <!-- Shown if current user is superadmin -->
                <li v-if="user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'role.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('role.index') }"
                    >
                        {{ $t('roles_and_permissions') }}
                    </router-link>
                </li>
                <!-- DRUG CARD -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'drug_card.index_novnr' }"
                        class="nav-link"
                        :class="{ active: activeLink('drug_card.index_novnr') }"
                    >
                        {{ $t('drug_card') }}
                    </router-link>
                </li>
                <!-- MEDICATION LIST -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'medications' }"
                        class="nav-link"
                        :class="{ active: activeLink('medications') }"
                    >
                        {{ $t('medication_list') }}
                    </router-link>
                </li>
                <!-- CUSTOM MEDICATIONS -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'customMedications.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('customMedications.index') }"
                    >
                        {{ $t('custom_medications') }}
                    </router-link>
                </li>
                <!-- LOGS -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'logs.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('logs.index') }"
                    >
                        {{ $t('logs') }}
                    </router-link>
                </li>
                <!-- INVENTORY -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'inventory' }"
                        class="nav-link"
                        :class="{ active: activeLink('inventory') }"
                    >
                        {{ $t('inventory') }}
                    </router-link>
                </li>
                <!-- RESERVATIONS -->
                <!-- Shown if user has show_user permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item">
                    <router-link
                        :to="{ name: 'reservation.index' }"
                        class="nav-link"
                        :class="{ active: activeLink('reservation.index') }"
                    >
                        {{ $t('reservations') }}
                    </router-link>
                </li>
                <!-- CREATE RESERVATION -->
                <!-- Shown if user has show_pharmacy permission and is not superadmin -->
                <li v-if="user.permissions.show_pharmacy && !user.permissions.superadmin" class="nav-item mt-3">
                    <router-link
                        :to="{ name: 'reservation.create' }"
                        class="nav-link"
                        :class="{ active: activeLink('reservation.create') }"
                    >
                        {{ $t('create_reservation') }}
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState('account', ['status', 'user'])
    },
    methods: {
        // check if link is active (= currently selected page)
        activeLink(name) {
            return this.$route.name === name;
        }
    }
};
</script>
